<template>
  <div align="center" style="width:1440px;margin:0 auto;height:100%;">
    <div style="width: 50%; margin-right: auto; margin-left: auto">
      <div style="margin-bottom:20px;">合肥光源各线站光闸打开时间统计</div>
      <div style="margin-bottom:20px;font-size:16px;">查询时间范围：{{ this.time1}}  到  {{this.time2}}</div>
      <el-table
        :data="gridData" style="width: 100%" 
        stripe
        :default-sort = "{prop: 'status', order: 'ascending'}"
         >
        <el-table-column prop="status" label="光束线编号" align="center"></el-table-column>
        <el-table-column prop="name" label="线站名称" align="center" width="200px"></el-table-column>
        <el-table-column prop="time" label="用光时间(h)" align="center"></el-table-column>
        <el-table-column prop="totaltime" label="查询总时间(h)" align="center"></el-table-column>
        <el-table-column prop="percent" label="百分比" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 2%" align="center">
      <el-date-picker
        v-model="value5"
        type="datetimerange"
        :picker-options="pickerOptions"
        range-separator="to"
        start-placeholder="start time"
        end-placeholder="end time" d
        align="right">
      </el-date-picker>
    </div>
    <div align="center" style="margin-top: 1%">
      <el-button v-on:click="query" type="primary" style="background-color: #004499; border-color: #004499"
                 :disabled="disabled">query
      </el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "piecharts",
    data() {


      this.chartSettings = {
        // dataType: 'percent'
      }
      return {
        disabled: false,
        pieLoading: false,
        legendVisible: false,
        gridData: [],
        pickerOptions: {
          shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近90天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value5: [new Date(Date.now() - 3600 * 24 * 1000), new Date(Date.now())],
        time1:null,
        time2:null

      }
    },
    mounted() {
      this.query();
    },
    methods: {
      query: function () {
        let date1 = new Date(this.value5[0]);
        let date2 = new Date(this.value5[1]);
        let inteval = date2 - date1
        let pieColor = ['#2E8B57', 'black', '#EE2C2C', '#3A5FCD', '#EEDC82']
        let _this = this;
        this.time1 = date1.format("yyyy-MM-dd hh:mm:ss");
        this.time2 = date2.format("yyyy-MM-dd hh:mm:ss");
        let startTime, endTime;
        let lastest = null;
        let n;
        let status = [];
        status = ["BL01B:WM0:Status", "BL03U:WM0:Status", "BL04B:WM0:Status", "BL07W:WM0:Status", "BL08B:WM0:Status","BL09U:WM0:Status","BL10B:WM0:Status","BL11U:WM0:Status","BL12:WM0:Status","BL12B:BS:Status","BL12C:BS:Status","BL13U:WM0:Status"];
        //status = ["BL07W:WM0:Status"]
        // let status = ["BL01B:WM0:Status"];
        // let status = ["BL01B:WM0:Status", "BL03U:WM0:Status", "BL04B:WM0:Status", "BL07W:WM0:Status","BL09U:WM0:Status","BL10B:WM0:Status","BL11U:WM0:Status","BL12:WM0:Status","BL12B:BS:Status","BL12C:BS:Status","BL13U:WM0:Status"];
        let statusName =["红外谱学和显微成像","燃烧","质谱","软X射线成像","计量","原子与分子物理","光电子能谱","催化与表面科学","磁圆二色/苏大线前端","磁圆二色","苏大线","角分辨光电子能谱"];
        let statusID = ["BL01B", "BL03U", "BL04B", "BL07W", "BL08B","BL09U","BL10B","BL11U","BL12","BL12B","BL12C","BL13U"];
        _this.pieLoading = true
        _this.gridData = []
        let q = new Array();
        for (let i = 0; i < 12; i++) {
            q.push(0)

            // _this.$axios.get('/hdars/hdars/api/history?pvListStr='+ status[i] + '&type=Max' + '&from='+date1.toISOString() + '&to=' + date2.toISOString())
             _this.$axios.get("/hlsTS/history/nameMap/" + status[i] +"@"+ "/"+" " +"/" + this.time1 + "/" + this.time2)
             // _this.$axios.get("/retrieval/retrieval/data/getData.qw?pv=" + status[i] + "&from=" + date1.toISOString() + "&to=" + date2.toISOString() + '&fetchLatestMetadata=true')

                  .then(function (response){
                    let responseData = response.data[status[i]];
                    n = responseData.length;
                    // if(responseData == null  || responseData === "" || responseData.length === 0 ){
                    if(response.data == null || response.data === "" || response.data.length === 0) {
                      _this.gridData.push({
                        status: statusID[i],
                        name:statusName[i],
                        time:"0",
                        totaltime:(_this.value5[1] - _this.value5[0]) / (1000 * 60 * 60),
                        percent:"0%"
                      })
                      return;
                    }
                    if (response.status != 200) {
                      _this.gridData.push({
                        status: statusID[i],
                        name:statusName[i],
                        time:"0",
                        totaltime:(_this.value5[1] - _this.value5[0]) / (1000 * 60 * 60),
                        percent:"0%"
                      })
                      return;
                    }
                    
                    
                    for (let j = 0; j <n; j++) {
                      if(responseData[j].float_val == 1){//1是出光，2是关，0和3是故障
                          if(parseInt(responseData[j].timestamp.slice(0,13)) < date1.getTime()){
                            let lastTime1 
                            if((j+1)< n ){
                              if(parseInt(responseData[j+1].timestamp.slice(0,13)) > date1.getTime()){
                                lastTime1 = parseInt(responseData[j+1].timestamp.slice(0,13)) - date1.getTime();
                              }else{
                                lastTime1 = 0;
                              }
                            }else{
                              lastTime1 = date2.getTime() - date1.getTime();
                            }
                            q[i] += lastTime1;
                          }else if(parseInt(responseData[j].timestamp.slice(0,13)) <= date2.getTime()  && parseInt(responseData[j].timestamp.slice(0,13)) >= date1.getTime()){
                            if((j+1) < n){
                              if(parseInt(responseData[j+1].timestamp.slice(0,13)) < date2.getTime()){
                                q[i] += parseInt(responseData[j+1].timestamp.slice(0,13)) - parseInt(responseData[j].timestamp.slice(0,13));
                              }
                            }else{
                              q[i] +=date2.getTime() - parseInt(responseData[j].timestamp.slice(0,13));
                            }
                          }else if(parseInt(responseData[j].timestamp.slice(0,13)) > date2.getTime()) {
                            q[i] += 0;
                          }
                      }
                    }
                    _this.gridData.push({              
                      status: statusID[i],
                      name:statusName[i],
                      time:(q[i] / (1000 * 60 * 60)).toFixed(2),
                      totaltime:((_this.value5[1] - _this.value5[0]) / (1000 * 60 * 60)).toFixed(2),
                      percent: parseFloat(q[i] / inteval * 100).toFixed(2) + "%"
                    })
                  }).catch(()=>{
                    _this.gridData.push({              
                      status: statusID[i],
                      name:statusName[i],
                      time:"null",
                      totaltime:((_this.value5[1] - _this.value5[0]) / (1000 * 60 * 60)).toFixed(2),
                      percent: "null"
                    })
                  })
          }
         
        
      }
    }
  }


</script>

<style scoped>
.el-table{
  background-color: #FFF!important;
}
.el-table th, .el-table tr {
    /* background-color: #eef3f7!important; */
    background-color: #FFF!important;
}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/beamlineOperStatics.vue